var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepLocatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.867,
    height: 106,
    viewBox: "0 0 125.867 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(23298 -18091.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(-23261.73 18143.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(31.114)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y1: 6.089,
    x2: 10.482,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(0 9.996)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y1: 14.169,
    x2: 24.389,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(7.225 9.419)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y1: 18.944,
    x2: 32.608,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(14.45 18.838)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y1: 13.723,
    x2: 23.621,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(-23298 18127.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M927.395,313.923a.634.634,0,0,0-.234-.882l-15.8-9.135a8.505,8.505,0,0,1-.649,1.142l15.8,9.109A.634.634,0,0,0,927.395,313.923Z",
    transform: "translate(-849.336 -303.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M936.8,349.2l-10.482,6.09a.649.649,0,0,0,.651,1.123l10.482-6.09a.649.649,0,1,0-.651-1.123Z",
    transform: "translate(-859.262 -333.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M837.371,392.755a.65.65,0,0,0,.887.236l24.389-14.168A.649.649,0,0,0,862,377.7l-24.388,14.168A.649.649,0,0,0,837.371,392.755Z",
    transform: "translate(-801.663 -351.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M891.7,376.288a.646.646,0,0,0-.887-.236L858.205,395a.649.649,0,0,0,.651,1.123l32.608-18.945A.649.649,0,0,0,891.7,376.288Z",
    transform: "translate(-815.037 -350.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M902.429,402.909l-23.622,13.722a.649.649,0,0,0,.651,1.123l23.622-13.722a.649.649,0,1,0-.651-1.123Z",
    transform: "translate(-828.414 -368.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M861.263,342.323s-.01,0-.014,0l-4.9-2.827a.648.648,0,0,0-.65,0l-12.88,7.485L825.9,337.233a.646.646,0,0,0-.882.234.663.663,0,0,0,.234.882l16.27,9.386-41.076,23.872a.786.786,0,0,0-.323.56l-.022,7.679c-.011,3.844-2.6,5-5.654,3.218l-56.757-32.777,34.153-19.827c-.7-.078-1.427-.182-2.128-.285l-33.659,19.542a.745.745,0,0,0-.316.581l-.016,5.634a.646.646,0,0,0,.324.563l15.427,8.905a.648.648,0,0,0,.649-1.123l-15.1-8.718.011-4.139,25.32,14.618L793.8,384.206c4.063,2.308,7.587.34,7.6-4.356l.019-6.56.831.48,2.768,1.6-.022,7.318c0,6.587-4.5,9.517-10.57,6.014l-30.862-17.818a.648.648,0,1,0-.649,1.123l30.862,17.818c2.755,1.59,6.016,2.378,8.765.827.027-.011.057-.007.084-.023L857.874,358.5c2.357-1.361,3.667-4.179,3.691-7.938l.023-7.679A.645.645,0,0,0,861.263,342.323ZM856.03,340.8l3.608,2.082-53.967,31.361-3.606-2.082Zm4.237,9.756c-.02,3.277-1.1,5.7-3.044,6.821l-51.889,30.168a11.594,11.594,0,0,0,.965-4.869l.02-7.3,53.967-31.362Z",
    transform: "translate(-735.721 -320.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M827.3,359.8a13.416,13.416,0,0,0,12.145,0c3.68-2.142,3.525-5.719-.026-7.786a9.991,9.991,0,0,0-3.374-1.168,7.143,7.143,0,0,1-.337,1.22,10.156,10.156,0,0,1,3.062,1.064c2.715,1.6,2.794,3.954.026,5.528a11.931,11.931,0,0,1-10.848,0c-2.741-1.528-2.787-3.958-.026-5.528a10,10,0,0,1,3.037-1.064,10.933,10.933,0,0,1-.311-1.246,10.174,10.174,0,0,0-3.4,1.194C823.566,354.186,823.772,357.776,827.3,359.8Z",
    transform: "translate(-793.408 -334.365)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M819.473,185.226c0-2.993-1.987-5.784-5.582-7.858a19.251,19.251,0,0,0-2.309-1.09v-1.644c2.475-1.581,3.849-3.634,3.856-5.838v-6.242s0,0,0,0,0-.012,0-.018c0-2.366-1.563-4.568-4.39-6.2-5.619-3.246-14.732-3.244-20.315,0-2.782,1.617-4.314,3.794-4.323,6.135,0,0,0,0,0,0v6.242c-.006,2.222,1.375,4.294,3.879,5.894l0,1.6a19.224,19.224,0,0,0-2.416,1.157c-3.535,2.055-5.484,4.815-5.5,7.775,0,0,0,0,0,.007v.029l0,7.234c-.008,3,1.972,5.8,5.576,7.881a25.054,25.054,0,0,0,10.072,2.953v2.6a11.9,11.9,0,0,0,.612,3.777l.98,3a1.369,1.369,0,0,0,2.613,0l.98-3a11.9,11.9,0,0,0,.612-3.777v-2.592a24.905,24.905,0,0,0,10.162-2.96c3.533-2.053,5.483-4.814,5.492-7.777l0-7.262s0,0,0,0S819.473,185.234,819.473,185.226Zm-8.907-3.658c0,1.37-.96,2.678-2.688,3.683a15.266,15.266,0,0,1-13.83,0c-1.767-1.021-2.739-2.348-2.735-3.738l-.005-6.338a22.337,22.337,0,0,0,19.253.021Zm-19.322-24.352c5.3-3.083,13.957-3.079,19.292,0,2.5,1.443,3.877,3.331,3.88,5.318,0,2.29-1.8,4.1-3.811,5.273-5.305,3.083-13.963,3.083-19.3,0C786.253,164.891,786.043,160.239,791.243,157.217Zm-3.816,11.5V165.7c.018.027.043.052.061.079a10.153,10.153,0,0,0,3.3,2.908c5.623,3.247,14.742,3.247,20.325,0a10.423,10.423,0,0,0,3.3-2.941v3.046c-.006,1.963-1.359,3.829-3.811,5.254-5.305,3.082-13.963,3.082-19.3,0C788.8,172.6,787.421,170.709,787.427,168.716Zm.956,9.535a17.431,17.431,0,0,1,1.9-.9l0,4.164c-.005,1.769,1.147,3.411,3.245,4.623a16.394,16.394,0,0,0,14.853,0c2.056-1.2,3.191-2.815,3.2-4.564l0-4.167a17.325,17.325,0,0,1,1.8.848c3.266,1.886,5.067,4.363,5.071,6.977,0,2.987-2.344,5.385-4.984,6.918-6.874,3.995-18.094,3.993-25.01,0-2.645-1.527-5.061-3.9-5.066-6.97C783.391,182.582,785.162,180.122,788.383,178.251Zm14.411,27.594a11.118,11.118,0,0,1-.551,3.471l-.98,2.981a.36.36,0,0,1-.694,0l-.98-2.981a11.117,11.117,0,0,1-.551-3.471V203.3c.647.039,1.29.107,1.94.107.609,0,1.211-.066,1.817-.1Zm15.656-16.985,0,3.654c-.008,2.584-1.777,5.033-4.984,6.9-6.871,3.994-18.089,3.993-25.009,0-3.273-1.891-5.072-4.376-5.065-7v-3.62a12.794,12.794,0,0,0,4.557,4.237,26.641,26.641,0,0,0,13.032,3.118c1.006,0,2.007-.072,3-.167a24.812,24.812,0,0,0,10-2.952A12.656,12.656,0,0,0,818.451,188.86Z",
    transform: "translate(-24058.857 17937.932)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepLocatorIcon);
export default __webpack_public_path__ + "static/media/rep-locator-icon.4adf907414aa7a604d3905ee492b9add.svg";
export { ForwardRef as ReactComponent };